export const COMMON = {
  active: "Active",
  in_active: "In Active",
  search: "Search",
  all: "All",
  action: "Action",
  save: "Save",
  save_and_continue: "Save and Continue",
  status: "Status",
  user_name: "User Name",
  name: "Name",
  name_error: "Name is required",
  name_length_error: "Name must be smaller than 50 characters",
  name_except_hyphen_error: "Numbers & special characters except hyphen is not allowed",
  user: "User",
  number: "Number",
  email: "Email",
  email_error: "Email is required",
  email_address: "Email Address",
  email_address_error: "Email Address is required",
  email_valid_error: "Invalid email",
  email_length_error: "Email must be smaller than 320 characters",
  role: "Role",
  serverError: "Server Error",
  serverErrorMsg: "Something went wrong please try again later",
  fixed: "Fixed",
  fixed_price: "Fixed Price",
  percentage: "Percentage",
  address: "Address",
  address_error: "Address is required",
  address_length_error: "Address must be smaller than 500 characters",
  phone: "Contact Number",
  phone_error: "Contact Number is required",
  city: "City",
  city_error: "City is required",
  filter: "Filter",
  add: "Add",
  last_update: "Last Updated",
  description: "Description",
  download: "Download",
  alert_continue_message: "Are you sure you want to continue?",
  alert_publish_message: "Are you sure, You want to publish this plan?",
  cancel: "Cancel",
  ok: "OK",
  description_error: "Description is required",
  line_of_business: "Line of Business",
  user_type_filter: "User Type",
  line_of_business_error: "Line of Business is required",
  formatError: "Invalid format",
  fileSizeError: "File size exceeds the limit",
  takaful_provider: "Takaful Provider",
  document: "Document",
  modifications: "Modifications",
  point_of_contact: "Point of Contact",
  all_permission: "All Permissions",
  update: "Update",
  create: "Create",
  view: "View",
  disable_delete: "Delete/Disable",
  edit: "Edit",
  none: "None",
  duplicate: "Duplicate",
  reject: "Reject",
  unreject: "Unreject",
  status_update_successfully: "Status Update Successfully",
  delete_successfully: "Delete Successfully",
  takaful_provider_error: "Takaful Provider is required",
  information: "Information",
  email_error_length: "Email cannot be exceed 320 characters",
  phone_number_error_invalid: "Invalid phone number",
  upload: "Upload",
  upload_list: "Upload List",
  download_list: "Download List",
  ntn_no: "NTN No #",
  ntn_no_validation: "NTN no contain only numbers",
  ntn_no_min_limit: "Character must be greater than 6",
  ntn_no_max_limit: "Character must be less than 8",
  decimal_error: "value can't be decimal",
  min_error: "value can't be less then ",
  max_error: "value can't be more then ",
  dropdown_value_error: "dropdown is required",
  minimum: "Minimum",
  maximum: "Maximum",
  month: "Month",
  month_error: "Month is required",
  year: "Year",
  year_error: "Year is required",
  url_pattern_error: "Url is not valid",
  taxes: "Taxes",
  confirm: "Confirm",
  date_range_picker_start_date: "Select Start Date",
  date_range_picker_end_date: "Select End Date",
  received: "Received",
  pending: "Pending",
  issued: "Issued",
  download_pdf: "Download Pdf",
  download_excel: "Download Excel",
  yes: "Yes",
  no: "No",
  monthly: "Monthly",
  annually: "Annually",
  publish: "Publish",
  room_limit_error: "Only 25 alphanumeric characters are accepted",
  date_rage_required: "Date range is required",
  select_region_and_province: "Select Region/Province",
  select_region_and_province_required_error: "Region/Province is required",
  select_region_and_province_title: "Region/Province",
  no_data: "No Data",
  loading: "Loading...",
  filer: "Filer",
  non_filer: "Non Filer",
  na: "N/A",
  close: "Close"
};
